<template>
  <v-dialog
    :value="dialogs.confirmTwoFactorAuthDialog"
    width="432"
    :transition="false"
    content-class="dialog-confirm-radius"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card
      class="dialog-confirm-radius"
    >
      <v-card-title
        class="dialog-confirm-title"
      >
        {{ $t('twoFactor.title') }}
      </v-card-title>

      <v-card-text>
        {{ $t('twoFactor.enterDigitsOrBackupCode') }}
      </v-card-text>

      <div class="enter-code-wrapper confirm-code-wrapper">
        <div class="enter-code-title">
          {{ $t('twoFactor.enterDigitsOrBackupCodeShort') }}
        </div>

        <div style="margin-top: 14px">
          <v-text-field
              v-model="code"
              rounded
              dense
              outlined
              :label="$t('twoFactor.enterDigitsOrBackupCodeShort')"
              :hide-details="!error"
              :error-messages="$t(`${error}`)"
              autofocus
              @keydown.enter="handleConfirm"
          />
        </div>

        <v-btn
          :disabled="code.length < 6"
          class="confirm-code-button"
          color="primary"
          width="100%"
          height="44px"
          :style="error ? 'margin-top: 0' : 'margin-top: 12px'"
          rounded
          :loading="loadingConfirm"
          @click="handleConfirm"
        >
          {{ $t('common.confirm') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: 'DialogTwoFactorAuthConfirm',

    props: {
      onCodeConfirm: {
        type: Function,
        required: true,

        default () {
          return 'Default function'
        }
      },
      turnOff: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        code: '',
        error: '',
        loadingConfirm: false
      }
    },

    computed: {
      ...mapGetters({
        dialogs: 'main/dialogs',
        twoFactorBackupCodes: 'main/twoFactorBackupCodes',
        twoFactorChangeDevice: 'main/twoFactorChangeDevice'
      }),
    },

    methods: {
      closeDialog () {
        this.$store.dispatch('main/closeDialog', 'confirmTwoFactorAuthDialog')
      },

      async handleConfirm () {
        this.loadingConfirm = true

        try {
          const codeKeyName = this.code.length === 6 ? 'code' : 'recovery_code'
          let response;

          if (this.turnOff) {
            response = await this.api.post('two-factory/disable', {
              [codeKeyName]: this.code
            })

            if (response.status === 200) {
              this.$store.dispatch('main/updateProfileLocally', {
                twoFactorEnableDisable: false
              })

              this.$store.dispatch('main/alert', {
                color: '#6F6F6F',
                message: this.$t('twoFactor.successfullyDisabled')
              })
            }
          } else if (this.twoFactorChangeDevice) {
            response = await this.api.post('two-factory/change-device', {
              [codeKeyName]: this.code
            })

            if (response.status === 200) {
              this.$store.dispatch('main/setTwoFactorQrCode', response.data['qr-code'])
              this.$store.dispatch('main/setTwoFactorSecretKey', response.data.secretKey)
            }
          } else {
            response = await this.api.post('two-factory/confirm', {
              [codeKeyName]: this.code
            })
          }

          if (response.status === 200) {
            this.$store.dispatch('main/closeDialog', 'confirmTwoFactorAuthDialog')
            this.onCodeConfirm() // invoke function from props
          }
        } catch (error) {
          this.error = 'twoFactor.invalidCode'
        } finally {
          this.loadingConfirm = false
        }
      }
    }
  }
</script>

<style>
  .dialog-confirm-title {
    font-weight: 500!important;
    font-size: 20px!important;
    line-height: 23px!important;
    letter-spacing: 0.15px!important;
    color: rgba(0, 0, 0, 0.87)!important;
    padding: 24px 24px 16px 24px!important;
  }

  .dialog-confirm-radius {
    border-radius: 32px;
  }

  .confirm-code-wrapper {
    padding: 8px 24px 24px 24px;
  }

  .confirm-code-button {
    text-transform: unset;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.5px;
  }
</style>
